type OnboardingProject = {
  id: string;
  name: string;
  folderId?: string | null;
};

type OnboardingFolder = {
  id: string;
  name: string;
};

export const selectOnboardingProject = (
  projects: OnboardingProject[] = [],
  folders: OnboardingFolder[] = [],
): OnboardingProject | null => {
  const sortedFolders = [...folders].sort((a, b) => a.name.localeCompare(b.name));

  for (const folder of sortedFolders) {
    const project = projects
      .filter((item) => item.folderId === folder.id)
      .sort((a, b) => a.name.localeCompare(b.name))[0];

    if (project) return project;
  }

  return projects.filter((item) => !item.folderId).sort((a, b) => a.name.localeCompare(b.name))[0] ?? null;
};
